<template>
  <div class="comm_btn_wrap">
    <button type="button" class="comm_btn_border">저장</button>
    <button type="button" class="comm_btn_border_Prime">저장</button>
    <button type="button" class="comm_btn_solid">결재상신</button>
    <button type="button" class="comm_btn_border" disabled="true">저장</button>
    <button type="button" class="comm_btn_border_Prime" disabled="true">저장</button>
    <button type="button" class="comm_btn_solid" disabled="true">결재상신</button>
    <sui-tooltip-menu class="big" :menu-list="menuList">Tooltip Menu</sui-tooltip-menu>
  </div>
</template>

<script>
export default {
    data() {return {
        menuList : [
            {key:'1', label: '맨위로 이동'},
            {key:'2', label: '위로 이동'},
            {key:'3', label: '아래로 이동'},
            {key:'4', label: '맨 아래로 이동'},
            {key:'5', label: '초기화'}
        ]
    }}
}
</script>